import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { NavigationService } from '../_services/navigation-service';
import { Subscription } from 'rxjs';
import { SettingsProvider } from '../_services/settingsProvider.service';
import { ConferenceCMSService, OrganizationService } from '../_services/generatedServices';
import { ConferenceViewModel, ConferenceViewModelWithDetails, OrganizationViewModel } from '../_models/generatedModels';
import { Title } from '@angular/platform-browser';
import { AnalyticsService } from '../_services/analytics.service';
import { SponsorshipCartService } from '../_services/sponsorship-cart.service';

@Component({
  selector: 'bxl-wiba-layout',
  templateUrl: 'conference-layout.component.html',
})
export class ConferenceLayoutComponent implements OnInit, OnDestroy {
  initialized = false;
  private parentRouteSubscription: Subscription;
  isHome = false;

  conference: ConferenceViewModel;
  organization: OrganizationViewModel;
  isCompanyAdmin: boolean;
  pages: any;

  constructor(private title: AnalyticsService, public auth: AuthenticationService, public cart: SponsorshipCartService, public settings: SettingsProvider, private route: ActivatedRoute, public nav: NavigationService, private router: Router, private orgService: OrganizationService, private cmsService: ConferenceCMSService) {}

  ngOnInit(): void {


    this.parentRouteSubscription = this.route.paramMap.subscribe((parentParam) => {
      var conferenceSlug = parentParam.get('conferenceSlug');
      console.log('confslugs: ' + conferenceSlug);

      this.orgService.getConferenceBySlugBasic(conferenceSlug).subscribe((conference) => {
        this.cmsService.getWebsitePagesForConference(conference.id.toString()).subscribe(
          (pages) => {
            this.pages = pages;

            this.organization = conference.organization;
            this.conference = conference;
            this.isCompanyAdmin = this.auth.isLoggedIn() && this.auth.isOrganizationAdmin(this.organization.id);

            if (this.organization.googleAnalyticsId) {
              (<any>window).gtag('config', this.organization.googleAnalyticsId);
            }

            if (!this.conference) {
              this.router.navigate(['/organizations/', this.organization.id]);
            } else {
              this.title.setTitleAndLogPageView(this.conference.name + ' - BehaviorLive');
            }
          },
          (error) => {
            this.router.navigate(['/notfound']);
          }
        );
      });
    });

    if (this.auth.isLoggedIn()) {
      this.auth.fetchUserProfile().subscribe((result) => {
        this.initialized = true;
      });
    }
  }

  logout() {
    this.auth.logout();
  }

  ngOnDestroy(): void {
    this.parentRouteSubscription.unsubscribe();
    console.log('destroyed');
  }
}
